var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { DataKind, ConditionPart } from '@easyquery/core';
import { DropDownRenderer } from '../dropdown_renderer';
import { PopupMenu } from '../../../utils/popup_menu';
import { QPEditablePart } from '../../../types/qp_editable_part';
var OperatorRenderer = /** @class */ (function (_super) {
    __extends(OperatorRenderer, _super);
    function OperatorRenderer(panel, condition, text, slot) {
        var _this = _super.call(this, slot) || this;
        _this.panel = panel;
        _this.condition = condition;
        _this.displayedText = text;
        return _this;
    }
    Object.defineProperty(OperatorRenderer.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-qp';
        },
        enumerable: true,
        configurable: true
    });
    OperatorRenderer.prototype.renderEditor = function () {
        var _this = this;
        //create menu
        var model = this.panel.getContext().getModel();
        var query = this.panel.getQuery();
        var items = [];
        var isRelatedToSubQuery = function (operator) {
            return operator.defaultOperand.kind == DataKind.Query;
        };
        var attrId = (this.condition && this.condition.expressions && this.condition.expressions[0]) ? this.condition.expressions[0].value : null;
        var attr = attrId ? model.getAttributeById(this.condition.expressions[0].value) : null;
        if (attr && attr.operators) {
            attr.operators.forEach(function (operId) {
                var operator = model.getOperatorById(operId);
                var related = isRelatedToSubQuery(operator);
                if (!query.isEx() && related) {
                    return;
                }
                if (operator && !(_this.panel.options.isSubQuery && related)) {
                    items.push({
                        id: operId,
                        text: i18n.getText('Operators', operId, 'caption') || operator.caption
                    });
                }
            });
        }
        var options = {
            items: items,
            adjustHeight: this.panel.options.adjustEntitiesMenuHeight,
            id: dataUtils.generateId('opmn'),
            domWriteItemsId: this.panel.options.domWriteItemsId
        };
        dataUtils.assign(options, this.panel.options.menuOptions);
        this.menu = new PopupMenu(options);
    };
    OperatorRenderer.prototype.getLabelText = function () {
        return this.displayedText;
    };
    OperatorRenderer.prototype.getEmptyText = function () {
        return this.panel.options.emptyTextOperator || i18n.getText('MsgEmptyOperator');
    };
    OperatorRenderer.prototype.getClassesToAdd = function () {
        return this.cssPrefix + "-condelement " + this.cssPrefix + "-operelement";
    };
    OperatorRenderer.prototype.isEditable = function () {
        return this.condition.enabled && !this.condition.isReadOnly()
            && ((this.panel.options.editableParts & QPEditablePart.Operator) === QPEditablePart.Operator);
    };
    OperatorRenderer.prototype.itemSelected = function (id) {
        this.condition.setOperatorId(id);
        this.condition.fireChangedEvent(ConditionPart.Operator);
    };
    OperatorRenderer.prototype.getMenu = function () {
        return this.menu;
    };
    return OperatorRenderer;
}(DropDownRenderer));
export { OperatorRenderer };
//# sourceMappingURL=operator_renderer.js.map